function equl(name) {
    var heading = document.querySelectorAll(name);
    var titleHeight = 0;

    heading.forEach((title) => {
        var totalHeight = title.offsetHeight;  // Includes padding and border
        if (totalHeight > titleHeight) {
            titleHeight = totalHeight;
        }
    });

    heading.forEach((divHeight) => {
        divHeight.style.paddingBottom = ""; // Clear previous padding
        divHeight.style.minHeight = titleHeight + "px";  // Apply consistent minHeight

        divHeight.offsetHeight; // Forces the layout to update immediately
    });
  }

  function updateLayout() {
    requestAnimationFrame(() => {
      equl(".custom_height .m-richtext__title , .custom_height .features_heading");
    });
  }

  // Run the script when the DOM content is fully loaded
  document.addEventListener("DOMContentLoaded", updateLayout);

  // Run the script on window load to handle initial layout
  window.addEventListener("load", updateLayout);

  // Run the script during resize to dynamically adjust on screen size changes
  window.addEventListener("resize", updateLayout);